import PropTypes from 'prop-types';
import React from 'react';
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from '@material-ui/core';
import {
  Check as CheckIcon,
  Clear as ClearIcon,
  DateRange as DateRangeIcon,
  Autorenew as AutorenewIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from '@material-ui/icons';
import {green, grey, red} from '@material-ui/core/colors';
import {useStyles} from 'util/Styles';

const green500 = green[500];
const red500 = red[500];
const grey500 = grey[500];
const ozgeneOrange = '#de7c1b';

function MilestoneList(props) {
  const {projectMilestones, stepIndex, onChangeStepIndex} = props;
  const classes = useStyles();
  const handleClick = ({milestone: {order}}) => onChangeStepIndex(order);
  const dateOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  const getTodoDisplayOptions = ({finished, todoStatus: {status}}) => {
    let todoIcon = null;
    let todoFinishedString = '';

    switch (status) {
      case 'Completed':
        todoIcon = <CheckIcon style={{margin: '0px', color: green500}} />;
        todoFinishedString = formatDate(finished);
        break;
      case 'Failed':
        todoIcon = <ClearIcon style={{margin: '0px', color: red500}} />;
        todoFinishedString = formatDate(finished);
        break;
      case 'Scheduled':
      case 'Started':
        todoIcon = <AutorenewIcon style={{margin: '0px', color: ozgeneOrange}} />;
        break;
      default:
        return false;
    }

    return {todoIcon, todoFinishedString};
  };
  const formatDate = (estimate) => new Date(estimate).toLocaleDateString('en-AU', dateOptions);
  const getIcon = ({todos, cnsProcedures}) =>
    todos.length === 0 ? ( // Milestone hasnt started yet
      <DateRangeIcon style={{margin: '0px', color: grey500}} />
    ) : cnsProcedures.length === 0 &&
      todos.every(({todoStatus: {status}}) => !['Started', 'Scheduled'].includes(status)) ? ( // no cnsProceures = no scheduled
      <CheckIcon style={{margin: '0px', color: green500}} />
    ) : (
      <AutorenewIcon style={{margin: '0px', color: ozgeneOrange}} />
    );
  const getFinishedString = ({todos, milestone: {order}, completedEstimate, cnsProcedures}) =>
    todos.length > 0 &&
    cnsProcedures.length === 0 &&
    todos.every(({todoStatus: {status}}) => !['Started', 'Scheduled'].includes(status))
      ? `Completed: ${formatDate(completedEstimate)}`
      : order !== 7
      ? `ECD: ${formatDate(completedEstimate)}`
      : '';

  return (
    <Stepper activeStep={stepIndex} linear="false" orientation="vertical">
      {projectMilestones.map((objectMilestone) => (
        <Step key={objectMilestone.milestone.id}>
          <StepLabel
            icon={getIcon(objectMilestone)}
            className={classes.tableRow}
            onClick={() => handleClick(objectMilestone)}
          >
            <Grid container>
              <Grid item xs={11} md={4} lg={3} xl={2}>
                <Typography variant="h6">{objectMilestone.milestone.name}</Typography>
              </Grid>
              <Grid item xs={1}>
                {stepIndex === objectMilestone.milestone.order ? (
                  <ExpandLessIcon style={{marginTop: 5}} />
                ) : (
                  <ExpandMoreIcon style={{marginTop: 5}} />
                )}
              </Grid>
            </Grid>
          </StepLabel>

          <StepContent>
            <Typography style={{color: 'black', opacity: 0.5}} variant="subtitle1">
              {getFinishedString(objectMilestone)}
            </Typography>
            <p>{objectMilestone.milestone.description}</p>
            <List>
              {objectMilestone.todos
                .sort((a, b) => {
                  if (!a.finished) {
                    return 1;
                  }
                  if (!b.finished) {
                    return -1;
                  }

                  return a.finished > b.finished ? 1 : -1;
                })
                .map((todo) => {
                  const {todoIcon, todoFinishedString} = getTodoDisplayOptions(todo);

                  return (
                    <ListItem key={todo.id}>
                      <ListItemIcon>{todoIcon}</ListItemIcon>
                      <ListItemText
                        primary={todo.cnsProcedure.name}
                        secondary={todoFinishedString}
                      />
                    </ListItem>
                  );
                })}
              {objectMilestone.cnsProcedures.map((cnsProcedure) => (
                <ListItem key={cnsProcedure.id}>
                  <ListItemIcon>
                    <DateRangeIcon style={{margin: '0px', color: grey500}} />
                  </ListItemIcon>
                  <ListItemText primary={cnsProcedure.name} />
                </ListItem>
              ))}
            </List>
          </StepContent>
        </Step>
      ))}
    </Stepper>
  );
}

MilestoneList.propTypes = {
  stepIndex: PropTypes.number.isRequired,
  projectMilestones: PropTypes.array.isRequired,
  onChangeStepIndex: PropTypes.func.isRequired,
};

export default MilestoneList;
